import { createContext, useContext } from 'react';
import { tSettingsContext } from './Settings.types';
import { SETTINGS_INITIAL_STATE } from './Settings.constants';

export const SettingsContext = createContext(SETTINGS_INITIAL_STATE);

export const useSettingsContext = (): tSettingsContext =>
  useContext(SettingsContext);
